module.exports = __webpack_public_path__ + "static/media/image1.6e4f8a8a.JPG";